module.exports = __webpack_public_path__ + "img/lite-pool-2.af34e9c4.jpg";